<template>
  <div>
    <div class="xian-A-1">
      <div class>
        <div class="outAreaTop"></div>
      </div>
      <div class="flex-row">
        <div class="left-A-1">
          <div class="outAreaBottom"></div>
          <div class="flex-row">
            <div class="left-A-1-left">
              <div class="computerRoomx">机房</div>
            </div>
            <div class="left-A-1-right flex-row">
              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row-r XA13 td3width2 margin-left-2td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A13"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>

              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row-r XA14 td3width2 margin-left-2td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A14"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>

              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row-r XA15 td3width2 margin-left-2td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A15"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-row">
            <div class="left-A-1-left">
              <div class="flex-align-end left-A-1-left-2">
                <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                  <div class="flex-row-r XA1 td3width2 margin-left-2td3">
                    <i class="XAzhuzi A1zhuzi"></i>
                    <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A1"
                      :key="i.seat">
                      <ul>
                        <li>姓名：{{ i.name || "" }}</li>
                        <li>区域：{{ i.region }}区</li>
                        <li>座位：{{ i.seat }}</li>
                        <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                      </ul>
                      <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                        :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                        {{ i.name ? i.name : "空置" }}
                        <!-- {{ i.seat }} -->
                      </el-button>
                    </el-popover>
                  </div>
                </div>
                <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                  <div class="flex-row-r XA2 td3width2 margin-left-1td3">
                    <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A2"
                      :key="i.seat">
                      <ul>
                        <li>姓名：{{ i.name || "" }}</li>
                        <li>区域：{{ i.region }}区</li>
                        <li>座位：{{ i.seat }}</li>
                        <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                      </ul>
                      <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                        :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                        {{ i.name ? i.name : "空置" }}
                        <!-- {{ i.seat }} -->
                      </el-button>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
            <div class="left-A-1-right flex-row">
              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row XA3 td3width2 margin-left-2td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A3"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>

              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row-r XA4 td3width2 margin-left-2td3">
                  <i class="XAzhuzi A4zhuzi"></i>
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A4"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>

              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row-r XA5 td3width2 margin-left-2td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A5"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="left-A-2">
          <div class="flex-row left-A-2-1">
            <div class="flex-row healthArea">
              <div class="xawc">WC</div>
              <div class="xaTreaRoom">公用茶水间</div>
              <div class="xaStairsRoom">楼梯间/垃圾台</div>
            </div>
            <div class="xaElevator">电梯</div>
            <div class="kong1"></div>
            <div class="xaElevator">电梯</div>
            <div class="xaElevator"></div>
            <div></div>
          </div>
          <div class="flex-align-end left-A-2-2">
            <div class="flex-align-end">
              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row XA20 td3width2">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A20"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>

              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row XA16 td3width2 margin-left-1td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A16"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>

              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row XA17 td3width2 margin-left-1td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A17"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>

              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row XA18 td3width2 margin-left-1td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A18"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>

              <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
                <div class="flex-row XA19 td3width2 margin-left-1td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A19"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="receptionArea">
              前台
              <div :class="checkList.includes('Z') ? 'Zqu' : 'Zqu-hidden'">
                <div class="flex-row XZ1 td3width2 margin-left-2td3">
                  <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.Z1"
                    :key="i.seat">
                    <ul>
                      <li>姓名：{{ i.name || "" }}</li>
                      <li>区域：{{ i.region }}区</li>
                      <li>座位：{{ i.seat }}</li>
                      <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                    </ul>
                    <el-button :id="i.name" :class="'common_td' + ' ' + i.name" slot="reference"
                      :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                      {{ i.name ? i.name : "空置" }}
                      <!-- {{ i.seat }} -->
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="xaReceptionRoom">接待室</div>
            <!-- <div class="teaArea">茶水间</div> -->
            <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
              <div class="flex-row-r B13 td3width2" style="width:2rem">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B13"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>

            <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
              <div class="flex-row-r B14 td3width2 margin-left-2td3">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B14"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>

          </div>
          <div class="flex-align-end left-A-2-3">
            <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
              <div class="flex-row-r XA6 td3width2">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A6"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>

            <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
              <div class="flex-row-r XA7 td3width2 margin-left-2td3">
                <i class="XAzhuzi A7zhuzi"></i>
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A7"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>

            <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
              <div class="flex-row-r XA8 td3width2 margin-left-2td3">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A8"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>

            <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
              <div class="flex-row-r XA9 td3width2 margin-left-2td3">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A9"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>

            <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
              <div class="flex-row XA10 td3width2 margin-left-2td3">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A10"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
                <i class="XAzhuzi A10zhuzi"></i>
              </div>
            </div>

            <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
              <div class="flex-row XA11 td3width2 margin-left-2td3">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A11"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>

            <div :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
              <div class="flex-row XA12 td3width2 margin-left-1td3">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.A12"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>

            <div class="metting" id="Seattle">
              会议室（西雅图）
              <i class="XAzhuzi xiyatuzhuzi"></i>
            </div>

            <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
              <div class="flex-row XB1 td3width2 margin-left-2td3">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B1"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
                <i class="XAzhuzi B1zhuzi"></i>
              </div>
            </div>
            <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
              <div class="flex-row-r XB2 td3width2 margin-left-2td3">
                <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B2"
                  :key="i.seat">
                  <ul>
                    <li>姓名：{{ i.name || "" }}</li>
                    <li>区域：{{ i.region }}区</li>
                    <li>座位：{{ i.seat }}</li>
                    <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

                  </ul>
                  <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
                    :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                    {{ i.name ? i.name : "空置" }}
                    <!-- {{ i.seat }} -->
                  </el-button>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../common.scss'

export default {
  data() {
    return {}
  },
  props: {
    seatData: {
      type: Object,
      default() {
        return {}
      }
    },
    checkList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    checkList(val) { },
    immediate: true
  }
}
</script>

<style lang="scss" scope>
.xian-A-1 {
  // width: 123rem;
  // border: 1px solid #000;
  position: relative;
  /* //竖列 A 排 第一块区域（横向A-1-06到A-1-01，竖向到底部） */
}

.outAreaTop {
  background-color: #d9d9d9;
  width: 122rem;
  height: 28rem;
}

.left-A-1 {
  width: 43.5rem;
}

.left-A-2 {
  width: 78.5rem;
  //  border: 1px solid #000;
}

.outAreaBottom {
  background-color: #d9d9d9;
  width: 100%;
  height: 30rem;
}

.computerRoomx {
  height: 25rem;
  width: 100%;
  line-height: 25rem;
  text-align: center;
  border: 1px solid #000;
}

.td3width2 {
  width: 4rem;
}

.left-A-1-left {
  width: 14rem;
}

.left-A-1-left-2 {
  height: 20rem;
}

.left-A-1-right {
  flex: 1;
}

.XA1,
.XA4,
.XA7,
.XA10,
.XAB1 {
  position: relative;
}

.A1zhuzi {
  bottom: 0;
  left: -5rem;
  position: absolute;
}

.A4zhuzi,
.A7zhuzi {
  bottom: 0;
  right: 4rem;
  position: absolute;
}

.A10zhuzi {
  margin-top: 2rem;
}

.B1zhuzi {
  margin-top: 2rem;
  position: relative;
  left: 2rem;
}

.left-A-2-1 {
  width: 100%;
  height: 26rem;
  margin: 5rem 6rem 3rem 6rem;
  text-align: center;

  .healthArea {
    width: 16rem;
    line-height: 13rem;

    .xawc {
      width: 100%;
      height: 13rem;
      border: 1px solid #000;
      border-bottom: none;
      font-size: 20px;
      line-height: 15rem;
    }

    .xaTreaRoom,
    .xaStairsRoom {
      height: 13rem;
      width: 8rem;
      border: 1px solid #000;
    }

    .xaStairsRoom {
      border-left: none;
    }
  }

  .xaElevator {
    border: 1px solid #000;
    line-height: 25rem;
    width: 14rem;
    border-left: none;
  }

  .kong1 {
    width: 4rem;
    border: 1px solid #000;
    border-left: none;
  }
}

.left-A-2-2 {
  height: 16rem;
  width: 100%;
  padding-left: 4rem;
  text-align: center;

  .receptionArea {
    position: relative;
    width: 20rem;
    height: 10rem;
    line-height: 10rem;

    .XZ1 {
      position: absolute;
      top: 6.5rem;
      left: 4rem;
    }
  }

  .xaReceptionRoom {
    border: 1px solid #000;
    // border-right: none;
    width: 10rem;
    height: 15rem;
    line-height: 10rem;
    border-top: none;
  }

  .teaArea {
    flex: 1;
    height: 12rem;
    line-height: 12rem;
    border: 1px solid #000;
  }
}

.left-A-2-3 {
  width: 100%;
  height: 25rem;
}

#Seattle {
  position: relative;
  width: 12rem;
  height: 15rem;
  line-height: 15rem;
  text-align: center;
  border: 1px solid #000;

  .xiyatuzhuzi {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
